module.exports = __webpack_public_path__ + "static/media/back_icon.be3da63f.svg";